// extracted by mini-css-extract-plugin
export default {"tabContainer":"License-module_tabContainer__kmU8B","namesAndPartiesTab":"License-module_namesAndPartiesTab__TPxRJ","itemsTab":"License-module_itemsTab__azp4k"};